import Formatter from '../helpers/formatter';

const products = {
  state: {
    products: [
      //{ id: 1,  name: 'Product 1', image: 'example.com/product1.jpg', ...}
    ],
    categories: [
      //{ id: 1, name: 'Videogames' }
    ],
    filterCategories: [
      //categoryId1, categoryId2 ...
    ],
    filterPointRange: {
      //minPoints: 5000, maxPoints:10000
    },
    sortByObj: {
      //sortByField: 'updated_at', sortByOrder: 'desc'
    },
    paginationInfo: {
      pageSize: 9,
      currentPage: 1,
      total: 0
    }
  },

  getters: {
    currentCategoryPaginationInfo: state => {
      return state.paginationInfo;
    },

    currentCategorySortByObj: state => {
      return state.sortByObj;
    },

    currentCategoryPointsFilter: state => {
      return state.filterPointRange;
    },

    filterProductsByCategory: state => () => {
      if (state.filterCategories.length > 0) {
        return state.products.filter(product => {
          let categoryIds = state.filterCategories;
          return categoryIds.indexOf(product.category_id) !== -1;
        });
      } else {
        return state.products;
      }
    },

    isFiltered: state => categoryId => {
      return state.filterCategories.find(cId => cId === categoryId);
    },

    currentCategory: state => categoryId => {
      return state.categories.find(category => category.id === categoryId);
    },

    getProducts: (state, getters) => () => {
      let products = getters.filterProductsByCategory();

      return products;
    }
  },

  mutations: {
    addCategories(state, categories) {
      state.categories = categories;
    },

    addProducts(state, products) {
      state.products = products;
    },

    addCategoryFilter(state, newCategoryId) {
      state.filterCategories = [
        ...state.filterCategories.filter(
          category => category !== newCategoryId
        ),
        newCategoryId
      ];
    },

    removeCategoryFilter(state, categoryId) {
      state.filterCategories = state.filterCategories.filter(category => {
        return category.id !== categoryId;
      });
    },

    toggleCategoryFilter(state, toggledCategoryId) {
      let isFiltered = state.filterCategories.find(category => {
        return category.id === toggledCategoryId;
      });

      if (isFiltered) {
        this.commit('removeCategoryFilter', toggledCategoryId);
      } else {
        this.commit('addCategoryFilter', toggledCategoryId);
      }
    },

    clearCategoryFilters(state) {
      state.filterCategories = [];
    },

    setPointRangeFilter(state, payload) {
      if (payload) {
        state.filterPointRange = Formatter.extend(
          state.filterPointRange,
          payload
        );
      } else {
        state.filterPointRange.maxPoints = undefined;
      }
    },

    setSortByObj(state, payload) {
      if (payload) {
        state.sortByObj = Formatter.extend(state.sortByObj, payload);
      } else {
        state.sortByObj.sortByField = undefined;
      }
    },

    setCategoryPaginationInfo(state, payload) {
      state.paginationInfo = Formatter.extend(state.paginationInfo, payload);
    }
  }
};

export default products;



// WEBPACK FOOTER //
// ./src/store/products.js